const fileModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/packageManagement/file-management/file-modal/file-modal.html',
  controller: 'FileModalController',
};

angular
  .module('package-management.module')
  .component('fileModal', fileModal);